import initCategories from './categories';

function init() {
  initCategories();
}

init();